import DeleteAccount from '@/pages/Settings/DeleteAccount.vue';
import EditSettings from '@/pages/Settings/EditSettings.vue';
import EditAccount from '@/pages/Settings/EditAccount.vue';
import EditContract from '@/pages/Settings/EditContract.vue';
import EditPassword from '@/pages/Settings/EditPassword.vue';
import EditPicture from '@/pages/Settings/EditPicture.vue';
import EditProfile from '@/pages/Settings/EditProfile.vue';
import context from '@/router/guards/context';
export default [
    {
        path: 'settings',
        name: 'settings',
        component: EditSettings,
        redirect: { name: 'settings.profile' },
        beforeEnter: [context],
        children: [
            {
                path: 'account',
                name: 'settings.account',
                component: EditAccount,
            },
            {
                path: 'picture',
                name: 'settings.picture',
                component: EditPicture
            },
            {
                path: 'contract',
                name: 'settings.contract',
                component: EditContract,
            },
            {
                path: 'password',
                name: 'settings.password',
                component: EditPassword,
            },
            {
                path: 'profile',
                name: 'settings.profile',
                component: EditProfile,
            },
            {
                path: 'delete',
                name: 'settings.delete',
                component: DeleteAccount,
            },
        ]
    },
];
